module.exports = new __parcel__URL__("soleil-nuage-2-pluie-3.407fc3e5.svg").toString();